// import { formatPlayer } from 'modules/player/format'

// Fonction pour formater le temps de jeu:
// - 1 seule unité normalement (ex: "54 minutes", "33 jours")
// - Au dessus d'une année: années et jours (ex: "2 années et 45 jours")
const formatPlayTime = (playTimeInSeconds) => {
  if (!playTimeInSeconds || playTimeInSeconds < 0) return 'Aucun'
  
  const totalSeconds = Math.floor(playTimeInSeconds)
  const years = Math.floor(totalSeconds / 31536000) // 365 jours
  const days = Math.floor((totalSeconds % 31536000) / 86400)
  const hours = Math.floor((totalSeconds % 86400) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  
  const plural = (n) => n > 1 ? 's' : ''
  
  // Si au moins 1 an : afficher ans et jours
  if (years >= 1) {
    if (days > 0) {
      return `${years} an${plural(years)} et ${days} jour${plural(days)}`
    }
    return `${years} an${plural(years)}`
  }
  
  // Sinon, afficher seulement la plus grande unité
  if (days >= 1) {
    return `${days} jour${plural(days)}`
  }
  
  if (hours >= 1) {
    return `${hours} heure${plural(hours)}`
  }
  
  if (minutes >= 1) {
    return `${minutes} minute${plural(minutes)}`
  }
  
  return `${totalSeconds} seconde${plural(totalSeconds)}`
}

export const formatPlayerAndRconPlayer = (player) => {
  // Format lisible: 1 unité (sauf >= 1 an: ans et jours)
  player.timePlayedFormatted = formatPlayTime(player.playTime)

  // timePlayer in seconds
  if (!player.playTime || player.playTime < 60 * 60 * 24 * 14) { // < 14 jours
    player.seniorityLabel = 'Débutant'
    player.isSeniorityBeginner = true
  } else if (player.playTime < 60 * 60 * 24 * 30) { // < 2 mois
    player.seniorityLabel = 'Habitué'
    player.isSeniorityRegular = true
  } else if (player.playTime < 60 * 60 * 24 * 30 * 6) { // < 6 mois
    player.seniorityLabel = 'Vétéran'
    player.isSeniorityVeteran = true
  } else if (player.playTime < 60 * 60 * 24 * 365 * 1) { // < 1 an
    player.seniorityLabel = 'Expert'
    player.isSeniorityExpert = true
  } else if (player.playTime < 60 * 60 * 24 * 365 * 2) { // < 2 ans
    player.seniorityLabel = 'Roleplayer'
    player.isSeniorityRolePlayer = true
  } else { // >= 2 ans
    player.seniorityLabel = 'No life'
    player.isSeniorityNoLife = true
  }

  return player
}
